import React from "react";
import Modal from "@streeteasy/design-system/deprecated/Modal";
import { debounce } from "lodash";
import { arrayOf, bool, number, shape, string } from "prop-types";

import ShareItemGA from "../../analytics/ga";
import ShareForm from "../ShareForm";
import { ModalPin } from "./styled";

class ShareItem extends React.Component {
  state = {
    isModalOpen: false,
    windowWidth: window.innerWidth
  };

  componentDidMount() {
    this.setWindowWidth();
    const { itemId, itemType } = this.props;
    this.uniqueEvent = `TriggerShareItemForm-${itemType}-${itemId}`;
    document.addEventListener(this.uniqueEvent, this.handleOpenModal);
  }

  componentWillUnmount() {
    document.removeEventListener(this.uniqueEvent, this.handleOpenModal);
  }

  setTheme = () => {
    if (this.state.windowWidth > 660) {
      return "lightBox";
    }

    return "default";
  };

  setWindowWidth = () => {
    const events = ["resize", "load"];

    events.forEach(event => {
      window.addEventListener(
        event,
        debounce(() => this.setState({ windowWidth: window.innerWidth }), 10)
      );
    });
  };

  commonType = itemType =>
    ["Sale", "Rental"].includes(itemType) ? "Listing" : itemType;

  handleMutationCompleted = data => {
    const isExclusiveMarketing =
      this.props.itemType === "Sale" &&
      !!this.props.exclusiveMarketingTokens.length;

    if (isExclusiveMarketing) {
      ShareItemGA.shareSubmitFormExclusiveMarketing(
        this.props.exclusiveMarketingTokens[0].token
      );
    } else {
      ShareItemGA.shareSubmitForm(
        this.props.itemType.toLowerCase(),
        this.props.itemId
      );
    }
    window.gon.state.analyticsData = { source: "share" };
    window.gon.state.triggerScenario("ShareConfirmation", {
      confirmationText: data.share_item.message,
      itemInfo: {
        itemId: this.props.itemId,
        itemType: this.props.itemType
      },
      email: data.share_item.email,
      origin: `share_${this.commonType(this.props.itemType).toLowerCase()}`,
      sharedType: this.commonType(this.props.itemType).toLowerCase()
    });

    this.setState({ isModalOpen: false });
  };

  handleOpenModal = () => {
    ShareItemGA.shareOpenModal(this.props.itemType.toLowerCase());
    this.setState({ isModalOpen: true });
  };

  handleCloseModal = () => {
    ShareItemGA.shareCloseModal(this.props.itemType.toLowerCase());
    this.setState({ isModalOpen: false });
  };

  render() {
    return (
      <ModalPin>
        <Modal
          isOpen={this.state.isModalOpen}
          onRequestClose={this.handleCloseModal}
          theme={this.setTheme()}
        >
          <ShareForm
            commonType={this.commonType}
            formErrorType={this.state.formErrorType}
            handleMutationCompleted={this.handleMutationCompleted}
            handleRenderError={this.handleRenderError}
            isAgent={this.props.isAgent}
            itemAddress={this.props.itemAddress}
            itemArea={this.props.itemArea}
            itemId={this.props.itemId}
            itemType={this.props.itemType}
            siteKey={this.props.siteKey}
            userEmail={this.props.userEmail}
          />
        </Modal>
      </ModalPin>
    );
  }
}

ShareItem.propTypes = {
  exclusiveMarketingTokens: arrayOf(
    shape({
      token: string,
      listing_provider_id: number
    })
  ),
  isAgent: bool,
  itemAddress: string.isRequired,
  itemArea: string.isRequired,
  itemId: string.isRequired,
  itemType: string.isRequired,
  siteKey: string.isRequired,
  userEmail: string.isRequired
};

ShareItem.defaultProps = {
  exclusiveMarketingTokens: [],
  isAgent: false
};

export default ShareItem;
